import { cn } from '@/lib/cn';

export function Skeleton({ className, rounded = 'rounded-control' }: { className?: string; rounded?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'block bg-raised',
        rounded,
        className,
      )}
    />
  );
}

export function ListSkeleton({ rows = 4, label = 'Loading' }: { rows?: number; label?: string }) {
  return (
    <div role="status" aria-label={label} className="space-y-3">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-card bg-surface p-4">
          <Skeleton className="h-12 w-12" rounded="rounded-full" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-9 w-20" />
        </div>
      ))}
    </div>
  );
}
